import Vue from 'vue'
import Accounting from 'accounting'
import store from '~/store'
import router from '~/router'
import i18n from '~/plugins/i18n'
import App from '~/components/App'

import '~/plugins'
import '~/components'
Vue.config.productionTip = false

Vue.filter('image', (image, parameter = null) => {
  if (!image) {
    return '/no-image.png'
  }

  if (!parameter) {
    return image.replace('image-service:', 'https://image-service.loewe-zaun.de')
  }

  const parts = image.split('/')
  parts.shift()
  const last = parts.pop()
  parts.push(parameter)
  parts.push(last)
  parts.unshift('https://image-service.loewe-zaun.de')
  return parts.join('/')
})

Vue.filter('currency', (value) => {
  return Accounting.formatMoney(value, '€', 2, ',', '.')
})

/* eslint-disable no-new */
new Vue({
  i18n,
  store,
  router,
  ...App
})
